import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import { DelayIcon } from 'assets/icons'
import RoundedIcon from 'components/RoundedIcon'
import { INTEREST_FREE_ADVANCE_MAX_AMOUNT } from 'constants/credit'
import { toLocaleCurrency } from 'utils/dinero'
import LineChart from 'assets/images/emojis/line-chart.png'
import GreenHeart from 'assets/images/emojis/green-heart.png'
import ModalContainer from 'components/ModalContainer'
import PrimaryButton from 'components/primaryButton'
import { toShortDateWithYear } from 'utils/date-fns'

const DepletedInterestFreeAdvances = ({
  expirationDate
}: {
  expirationDate: Date
}) => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_consumiste_tasa_0' })
  }, [])

  return (
    <div className='text-center text-black'>
      <h2 className='font-bold leading-5'>
        Agotaste tu línea de <br /> crédito a Tasa 0%
      </h2>
      <DelayIcon className='mx-auto my-4' />
      <p className='text-xs leading-4 mb-4'>
        Ya obtuviste los ${toLocaleCurrency(INTEREST_FREE_ADVANCE_MAX_AMOUNT)}{' '}
        disponibles por mes, podés intentar de nuevo el{' '}
        {toShortDateWithYear(expirationDate)}
      </p>
      <div className='flex gap-2 text-left leading-[14px] mb-4 items-center'>
        <RoundedIcon
          className='h-6 w-6'
          icon={<img className='shrink-0 w-3 h-auto' src={LineChart} alt='' />}
        />
        <p className='font-medium text-2xs'>
          Aumentá tus limites pagando tus cuotas en tiempo y accedé a nuevos
          montos cuando finalices el crédito.
        </p>
      </div>
      <div className='flex gap-2 text-left leading-[14px] items-center'>
        <RoundedIcon
          className='h-6 w-6'
          icon={<img className='shrink-0 w-3 h-auto' src={GreenHeart} alt='' />}
        />
        <p className='font-medium text-2xs'>
          Con Wayni+ tus límites se actualizan más rápido y con mejores tasas.
        </p>
      </div>
    </div>
  )
}

export default DepletedInterestFreeAdvances

export const DepletedInterestFreeModal = ({
  isOpen,
  setIsOpen,
  expirationDate
}) => (
  <ModalContainer isShown={isOpen} setModalFunction={setIsOpen} noCloseButton>
    <DepletedInterestFreeAdvances expirationDate={expirationDate} />
    <PrimaryButton
      className='mt-8'
      buttonText='¡Entendido!'
      primaryButtonFunction={() => setIsOpen(false)}
    />
  </ModalContainer>
)
